<template>
    <article class="i-bond-issues">
        <h2
            class="i-bond-issues__header"
            :title="bondIssuesData.header"
            v-html="bondIssuesData.header"></h2>
        <div class="i-bond-issues__wrap">
            <div class="i-bond-issues__img">
                <img
                    :src="bondIssuesData.image"
                    alt="График"
                    title="График"
                    width="256"
                    height="148" />
            </div>
            <div class="i-bond-issues__info">
                <div class="i-bond-issues__info-wrap">
                    <span
                        class="i-bond-issues__name"
                        v-html="bondIssuesData.issues.name"></span>
                    <output
                        class="i-bond-issues__val"
                        v-html="apiData.issues + ' ' + declineIssues"></output>
                </div>
                <div class="i-bond-issues__info-wrap">
                    <span
                        class="i-bond-issues__name"
                        v-html="bondIssuesData.sum.name"></span>
                    <output
                        class="i-bond-issues__val"
                        v-html="apiData.sum + ' ₽'"></output>
                </div>
            </div>
        </div>
        <div class="i-bond-issues__footer">
            <span
                class="i-bond-issues__date"
                v-html="bondIssuesData.date"></span>
            <a
                class="i-bond-issues__link arrow-btn"
                :href="bondIssuesData.link"
                :target="bondIssuesData.link.includes('://') ? '_blank' : '_self'"></a>
        </div>
    </article>
</template>

<script>
    import declineWordOfNum from '../../modules/decline-word-of-num'

    export default {
        name: 'BondIssues',
        props: {
            bondIssuesData: {
                type: Object,
                default: () => {}
            },
            apiData: {
                type: Object,
                default: () => {}
            }
        },
        computed: {
            declineIssues() {
                return declineWordOfNum(this.apiData.issues, ['выпуск', 'выпуска', 'выпусков'])
            }
        }
    }
</script>